import React, { useState, useContext } from 'react';
import axios from "../../../axios/index"

import { UserContext } from '../../Context/UserContextProvider';

import Modal from 'react-bootstrap/Modal';
import { Form } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { removeCommas } from "@persian-tools/persian-tools";

// ModalStyles
import styles from "../StaffManagment/StaffManagment.module.css";
import ModalStyles from "../DashboardReuseAbleComponents/Modal.module.css";

const FinancialSettlementRequestModal = (props) => {
    const { userToken, userData } = useContext(UserContext);
    const [btnLoader, setBtnLoader] = useState(false)
    const [data, setData] = useState({
        price: "",
        cardNumber: ""
    })

    const addCommas = (num) =>
        num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = (num) => num?.toString().replace(/[^0-9]/g, "");

    const formChangeHandler = (e) => {
        if (e.target.name === "price") {
            setData({
                ...data,
                [e.target.name]: removeCommas(e.target.value)
            });

        } else if (e.target.value.length <= 16) {
            setData({
                ...data,
                cardNumber: e.target.value
            });
        }
    }

    return (
        <>
            <style type="text/css">
                {`
                .modal {
                    background: #3335;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
            `}
            </style>

            <ToastContainer
                position="top-right"
                autoClose={10000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            <Modal
                show={props.show}
                onHide={props.onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton dir='rtl'>
                    <div className='w-100 d-flex align-items-start justify-content-between px-3'>
                        <div className={ModalStyles.title}>
                            درخواست تسویه مالی
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body dir="rtl" className={`my-3`}>
                    <div className={`w-100 mx-auto px-3 text-center ${styles.total_modal_body_files_box}`}>
                        <h3 className={`${styles.title_modal_body_files_box}`}> لطفا مبلغ مورد نظر و شماره کارت خود را وارد کنید </h3>

                        <div className={`w-100 d-flex align-items-center justify-content-between flex-wrap pt-3 my-4 ${styles.total_percentage_modal_body_files_box}`}>
                            <Form.Group className={`position-relative my-3 my-md-0 ${styles.consultant_modal_financial_container}`}>
                                <Form.Label className={`w-100 mb-2 text-right ${styles.title_percentage_modal_body_files_box}`}> مبلغ تسویه </Form.Label>
                                <Form.Control
                                    className={`${styles.form_percentage_modal_body_files_box} shadow-none`}
                                    type="text"
                                    id="price"
                                    name="price"
                                    value={addCommas(removeNonNumeric(data.price))}
                                    onChange={formChangeHandler}
                                />
                                <Form.Text className={`position-absolute top-50 start-0 px-3`}> تومان </Form.Text>
                            </Form.Group>
                            <Form.Group className={`position-relative my-3 my-md-0 ${styles.consultant_modal_financial_container}`}>
                                <Form.Label className={`w-100 mb-2 text-right ${styles.title_percentage_modal_body_files_box}`}> شماره کارت شما </Form.Label>
                                <Form.Control
                                    className={`${styles.form_percentage_modal_body_files_box} shadow-none`}
                                    type="text"
                                    id="pourcentPercentage"
                                    name="pourcentPercentage"
                                    value={data.cardNumber}
                                    onChange={formChangeHandler}
                                />
                            </Form.Group>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='w-100 d-flex justify-content-center align-items-center mb-3'>
                        {btnLoader ? (
                            <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`} >
                                <div className={ModalStyles.btn_loader_container}>
                                    <div className={ModalStyles.btn_spinner}></div>
                                </div>
                            </div>
                        )
                            : (
                                <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`} onClick={submitHandler}>
                                    ارسال
                                </div>
                            )
                        }
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );

    function validateCard(card) {
        if (typeof card === 'undefined'
            || card === null
            || card.length !== 16) {
            return false;
        }
        let cardTotal = 0;
        for (let i = 0; i < 16; i += 1) {
            const c = Number(card[i]);
            if (i % 2 === 0) {
                cardTotal += ((c * 2 > 9) ? (c * 2) - 9 : (c * 2));
            } else {
                cardTotal += c;
            }
        }
        return (cardTotal % 10 === 0);
    }

    function submitHandler() {
        if (data.price !== "" && validateCard(data.cardNumber)) {
            notify("درحال ارسال درخواست شما", "success")
        } else if (!validateCard(data.cardNumber)) {
            notify("شماره کارت وارد شده صحیح نمیباشد", "error")
        } else {
            notify("!لطفا تمام فیلد هارا پرکنید", "error")
        }
    }


    function notify(text, type) {
        if (type === "success") {
            toast.success(text, {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            settlementRequest()
        } else if (type === "posted-success") {
            toast.success(text, {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else if (type === "posted-error") {
            toast.error(text, {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(text, {
                position: "top-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setBtnLoader(false)
        }
    };

    async function settlementRequest() {
        try {
            setBtnLoader(true)
            var requestData = new FormData();
            requestData.append('UserId', userData.id);
            requestData.append('Price', data.price);
            requestData.append('CardNumber', data.cardNumber);
            const apiData = await axios.post(
                "SettlementRequest",
                requestData,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            if (apiData.data.isSuccess) {
                notify("درخواست شما با موفقیت ارسال شد", "posted-success")
            }
        } catch (error) {
            //console.log(error)
        } finally {
            setBtnLoader(false)
            props.onHide()
        }

    }
};

export default FinancialSettlementRequestModal;